import React, { ReactNode } from 'react';
import { get } from 'lodash';
import { Button } from 'vetrf-ui';
import styles from './Timeline.module.scss';

type TimelineProps<T> = {
  dateField: string;
  nameField: string;
  defaultNameField: string;
  data: T[];
  onRemove: (item: T) => void;
  render: (item: T) => ReactNode;
  allowRemove: boolean;
  onlyLastRemove?: boolean;
  subtitle?: string;
};

export const Timeline = <T,>({
  dateField,
  nameField,
  defaultNameField,
  data,
  onRemove,
  render,
  allowRemove,
  onlyLastRemove = false,
  subtitle,
}: TimelineProps<T>) => (
  <div className={styles.timelineContainer}>
    {data.map((item, index) => (
      <div className={styles.timelineItem} key={get(item, 'id')}>
        <div className={styles.timelineInfo}>
          <span className={styles.timelineDate}>{get(item, dateField)?.slice(0, 10)}</span>
          <div className={styles.timelineIndicator} />
        </div>
        <div className={styles.widgetBox}>
          <div className={styles.widgetBody}>
            <div className={styles.widgetMain}>
              <span className={styles.widgetMainHeader}>
                {get(item, nameField, undefined) || get(item, defaultNameField, '')}
                {subtitle && ` (${get(item, subtitle, '')})`}
                {allowRemove &&
                  data.length > 1 &&
                  (!onlyLastRemove || (onlyLastRemove && index === data.length - 1)) && (
                    <Button
                      icon="remove"
                      iconColor="red"
                      iconSize={100}
                      onClick={() => {
                        onRemove(item);
                      }}
                      onlyIcon
                      tooltip="Удалить"
                    />
                  )}
              </span>
              <span className={styles.widgetInfo}>{render(item)}</span>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);
